export default __webpack_public_path__ + "static/media/sales.816fe490.svg";